<template>
  <section class="section not-found">
    <h1>404</h1>
    <p>
        Sorry, we could not find this page.
    </p>
  </section>
</template>

